<template>
    <label :for="`${id}-country-code`"></label>
    <select class="form-control" :id="`${id}-country-code`" ref="self" @input="updateValue" >
        <option :value="country.dialCode" v-for="country in countries" :key="country">
            {{ country.name }} +{{ country.dialCode }}
        </option>
    </select>
</template>
<script>
import CountryCode from "./CountryCode.js";

export default {
    props: {
        id: String,
        modelValue: String,
    },
    data() {
        return {
            countries: CountryCode
        }
    },
    mounted() {
        this.$refs.self.value = this.modelValue;
    },
    methods: {
        updateValue(event) {
            this.$emit("update:modelValue", event.target.value);
        }
    },
}
</script>
